export const NONE = { id: 'none', label: 'Nessuna consaguineità' };
export const DEGREE_1 = {
  id: 'degree_1',
  label: 'Cugini di 1° grado (figli di fratelli o sorelle)',
};
export const DEGREE_2 = { id: 'degree_2', label: 'Cugini di 2° grado (figli di cugini)' };
export const DEGREE_3 = { id: 'degree_3', label: 'Cugini di 3° grado (figli di figli di cugini)' };
